import React, { useState, useEffect } from 'react';
import { Typography } from '@mui/material';

// Vistas
import AiPlansPricing from './AiPlansPricing';
import MetaOnboarding from './MetaOnboarding';
import AiDashboard from './AiDashboard';

// Controladores y Componentes
import { checkAiSubscriptionStatus } from '../../../controllers/company/ai/AiController';
import QUDProgress from '../../../components/progress';

const WhatsAppAiModule = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [aiState, setAiState] = useState(null); 
    const [moduleData, setModuleData] = useState({}); 

    useEffect(() => {
        checkStatus();
    }, []);

    const checkStatus = async () => {
        setIsLoading(true);
        try {
            const response = await checkAiSubscriptionStatus();
            if (response.success) {
                console.log('CHECK STATUS ===> ',response);
                const { data } = response.data; 
                setAiState(response.data.state);
                setModuleData(response.data);
            }
        } catch (error) {
            console.error("Error obteniendo el estado del Agente IA", error);
            setAiState(0);
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return <QUDProgress open={isLoading} />;
    }

    // Máquina de estados para el renderizado
    switch (aiState) {
        case 0:
            return (
                <AiPlansPricing
                    onPaymentSuccess={checkStatus} 
                />
            );
        case 1:
            return (
                <MetaOnboarding
                    planName={moduleData.plan_name}
                    metaAppId={moduleData.meta_app_id}
                    metaConfigId={moduleData.meta_config_id}
                    onConnectionSuccess={checkStatus} 
                />
            );
        case 2:
            return (
                <AiDashboard 
                    agentMode={moduleData.agent_mode} 
                    waNumber={moduleData.wa_number} 
                    isActive={moduleData.is_active} 
                />
            );
        default:
            return <Typography>Error: Estado desconocido.</Typography>;
    }
};

export default WhatsAppAiModule;